import { HttpClient } from '@angular/common/http'
import { inject, Injectable, signal } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { environment } from '../../../environments/environment'
import { FeatureFlag, FeatureFlagKeys } from '../types/feature-flag.type'
import { ApiResponse } from '../types/response.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class FeatureFlagService {
	http = inject(HttpClient)

	featureFlags = signal<Record<string, boolean>>({})

	fetchFeatureFlags(): Observable<ApiResponse<FeatureFlag[]>> {
		return this.http.get<ApiResponse<FeatureFlag[]>>(`${API_URL}/api/feature-flag`).pipe(
			tap((response) => {
				const features = response?.result
				if (response?.status === 'ok' && features?.length > 0) {
					const featureFlags: Record<string, boolean> = {}
					features?.forEach((item: FeatureFlag) => {
						featureFlags[item.NAME] = item?.IS_ENABLED
					})
					this.featureFlags.set(featureFlags)
				}
			}),
		)
	}

	getFeature(feature: FeatureFlagKeys): boolean {
		return this.featureFlags()[feature] ?? false
	}
}
